import { useState, type FormEvent } from 'react';
import { useAuth } from '@/auth/AuthContext';
import { Alert, AuthLayout, Button, Field } from '@/components/ui';
import { api } from '@/lib/api';
import { errorMessage } from '@/lib/errors';

export function LoginPage() {
  const { refresh } = useAuth();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await api.post('/auth/login', { email, senha });
      await refresh();
    } catch (err) {
      setError(errorMessage(err));
      setSenha('');
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthLayout step="PASSO 1 DE 2" title="Entrar" subtitle="Use o e-mail cadastrado pelo administrador.">
      <form className="stack" onSubmit={(e) => void submit(e)}>
        {error && <Alert>{error}</Alert>}
        <Field
          label="E-mail"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="username"
          autoFocus
          required
        />
        <Field
          label="Senha"
          type="password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          autoComplete="current-password"
          required
        />
        <Button type="submit" loading={loading}>
          Continuar
        </Button>
        <p className="muted small center">Esqueceu a senha? Peça ao administrador para gerar uma nova.</p>
      </form>
    </AuthLayout>
  );
}
